var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoType = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 502 123"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logo-type_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#503A3A",
  d: "M430.802 69.296C323.207 24.546 180.088 23.9 70.167 60.049L48.597 0h-14.48l7.067 13.064C37.924 21.486 3.808 118.815 0 122.993h25.672L13.78 109.756c.49-1.373 7.21-19.919 7.369-20.579 11.914-7.23 26.959-14.294 40.988-19.581 4.162 11.534 10.68 29.435 14.871 41.022L71.147 123H100.1l-12.576-14.422-15.301-42.642c115.347-39.013 314.815-38.93 410.496 43.377l-6.413 13.695s25.672.029 25.695-.015c-12.494-20.227-36.713-38.653-71.198-53.682zM46.324 69.28v.015c-7.887 3.427-15.218 7.05-22.014 10.822L44.984 22.22l15.03 41.488a307 307 0 0 0-13.683 5.564z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-type_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h502v123H0z"
})))));
export default SvgLogoType;